import { useMemo, useState } from 'react';

import { type AirActionTrackingLocation } from '@air/analytics';
import { type ScopedPermissions, type ShortUrlResponse } from '@air/api/types';
import { type TabPanel } from '@air/primitive-tabs';

import { SharePrivateBoardLinkInfo } from '~/components/SharePrivateBoardModal/SharePrivateBoardLinkInfo';
import { SharePrivateBoardSettings } from '~/components/SharePrivateBoardModal/SharePrivateBoardSettings';
import { SharePrivateContentTabs } from '~/components/SharePrivateContentModal/SharePrivateContentTabs';

export type SharePrivateBoardEditProps = {
  boardId: string;
  trackLocation: AirActionTrackingLocation;
  shortIdInfo: ShortUrlResponse;
  userPermissions: ScopedPermissions;
};

export const SharePrivateBoardTabs = ({
  boardId,
  trackLocation,
  shortIdInfo,
  userPermissions,
}: SharePrivateBoardEditProps) => {
  const [activeTab, setActiveTab] = useState('link');

  const panels = useMemo<TabPanel[]>(() => {
    return [
      {
        id: 'link',
        label: 'Link',
        content: (
          <SharePrivateBoardLinkInfo
            goToSettings={() => setActiveTab('settings')}
            boardId={boardId}
            shortIdInfo={shortIdInfo}
            trackLocation={trackLocation}
            userPermissions={userPermissions}
          />
        ),
      },
      {
        id: 'settings',
        label: 'Settings',
        content: (
          <SharePrivateBoardSettings boardId={boardId} shortIdInfo={shortIdInfo} userPermissions={userPermissions} />
        ),
      },
    ];
  }, [boardId, shortIdInfo, trackLocation, userPermissions]);

  return <SharePrivateContentTabs setActiveTab={setActiveTab} activeTab={activeTab} panels={panels} />;
};
